"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Browser_1 = require("../utils/Browser");
/**
 * Add the given range into selection of the given document
 * @param range The range to select
 * @param skipSameRange When set to true, do nothing if the given range is the same with current selection,
 * otherwise it will always remove current selection range and set to the given one.
 * This parameter is always treat as true in Edge to avoid some weird runtime exception.
 */
function addRangeToSelection(range, skipSameRange) {
    var _a, _b, _c;
    var selection = (_c = (_b = (_a = range === null || range === void 0 ? void 0 : range.commonAncestorContainer) === null || _a === void 0 ? void 0 : _a.ownerDocument) === null || _b === void 0 ? void 0 : _b.defaultView) === null || _c === void 0 ? void 0 : _c.getSelection();
    if (selection) {
        var needAddRange = true;
        if (selection.rangeCount > 0) {
            // Workaround IE exception 800a025e
            try {
                var currentRange = void 0;
                // Do not remove/add range if current selection is the same with target range
                // Without this check, execCommand() may fail in Edge since we changed the selection
                if ((skipSameRange || Browser_1.Browser.isEdge) &&
                    (currentRange = selection.rangeCount == 1 ? selection.getRangeAt(0) : null) &&
                    currentRange.startContainer == range.startContainer &&
                    currentRange.startOffset == range.startOffset &&
                    currentRange.endContainer == range.endContainer &&
                    currentRange.endOffset == range.endOffset) {
                    needAddRange = false;
                }
                else {
                    selection.removeAllRanges();
                }
            }
            catch (e) { }
        }
        if (needAddRange) {
            selection.addRange(range);
        }
    }
}
exports.default = addRangeToSelection;
//# sourceMappingURL=addRangeToSelection.js.map